import isBlank from '../../common/helpers/isBlank';

const validateMetaDataFormValues = (formValues) => {
  const services =
    formValues.services && formValues.services.length > 0
      ? ''
      : 'Please select a service or product.';

  const result = {
    dealType: isBlank(formValues.dealType) ? 'Deal type is required' : '',
    clientName: isBlank(formValues.clientName)
      ? 'Please enter the client name.'
      : '',
    projectName: isBlank(formValues.projectName)
      ? 'Project name is required'
      : '',
    isClientTarget: isBlank(formValues.isClientTarget)
      ? 'Client target is required'
      : '',
    industryId: isBlank(formValues.industryId) ? 'Industry is required' : '',
    targetIndustryId:
      formValues.isClientTarget === 'false' &&
      isBlank(formValues.targetIndustryId)
        ? 'Target industry is required'
        : '',
    services,
  };

  return result;
};

export default validateMetaDataFormValues;
